var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lk-row',{staticClass:"mb8"},[_c('lk-table',{attrs:{"border":"","columns":_vm.cols,"data":_vm.tableData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }